module.exports = __webpack_public_path__ + "img/services-slogan.76fd07cd.png";